import { useEffect, useRef } from 'react';

// Only non-sensitive layout dimensions cross the iframe boundary.
export function useEmbedHeight(enabled) {
  const ref = useRef(null);
  useEffect(() => {
    if (!enabled || window.parent === window || !ref.current) return;
    let parentOrigin;
    try { parentOrigin = new URL(document.referrer).origin; } catch { return; }
    if (parentOrigin === 'null') return;
    const element = ref.current;
    let frame, lastHeight = 0;
    const report = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const height = Math.ceil(element.getBoundingClientRect().height);
        if (height > 0 && height !== lastHeight) {
          lastHeight = height;
          window.parent.postMessage({ type: 'valuebot:height', height }, parentOrigin);
        }
      });
    };
    const onMessage = event => {
      if (event.source !== window.parent || event.origin !== parentOrigin) return;
      if (event.data?.type === 'valuebot:measure') { lastHeight = 0; report(); }
      // Keep episode dialogs inside the visible part of a tall iframe.
      if (event.data?.type === 'valuebot:viewport') {
        const { top, height } = event.data;
        if (!Number.isFinite(top) || !Number.isFinite(height) || top < 0 || height < 1) return;
        document.documentElement.style.setProperty('--embed-dialog-top', `${top + height / 2}px`);
        document.documentElement.style.setProperty('--embed-dialog-height', `${height * 0.85}px`);
        document.documentElement.dataset.valuebotEmbed = 'true';
      }
    };
    const observer = new ResizeObserver(report);
    observer.observe(element);
    window.addEventListener('message', onMessage);
    report();
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('message', onMessage);
      delete document.documentElement.dataset.valuebotEmbed;
      document.documentElement.style.removeProperty('--embed-dialog-top');
      document.documentElement.style.removeProperty('--embed-dialog-height');
    };
  }, [enabled]);
  return ref;
}
